import { AxiosResponse } from 'axios';
import api from '../contexts/GlobalContext';

export interface FreezeSetting {
  id: number
  start_datetime: string
  end_datetime: string
  is_active: boolean
  created_by: number
  created_at: string
  updated_at: string
}

export interface FreezeStatus {
  is_frozen: boolean
  can_bypass: boolean
  freeze_info: Pick<FreezeSetting, 'start_datetime' | 'end_datetime'> | null
}

export const getFreezeStatus = async (): Promise<AxiosResponse<FreezeStatus>> => api.get<FreezeStatus>('/confirm-freeze/status', { silent: true, timeout: 15000 });

export const getCurrentFreeze = async (): Promise<AxiosResponse<FreezeSetting | null>> => api.get<FreezeSetting | null>('/confirm-freeze/current');

export const setFreeze = async (data: { start_datetime: string, end_datetime: string }): Promise<AxiosResponse<FreezeSetting>> => api.post<FreezeSetting>('/confirm-freeze', data);

export const deactivateFreeze = async () => api.post('/confirm-freeze/deactivate');
